import React from "react";
import { Box, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BoltIcon from "@mui/icons-material/Bolt";
import { useTranslation } from "react-i18next";
import CustomCard from "../../shared/CustomCard";

const reportGroups = [
  { title: "Eligibility", reports: [
    { title: "Eligibility Report", icon: AssessmentOutlinedIcon, progessMessage: "Eligibility reports are currently being developed." },
    { title: "Not Eligible Report", icon: DescriptionOutlinedIcon, progessMessage: "Eligibility reports are currently being developed." },
    { title: "Payer Wise Eligibility", icon: AccountBalanceOutlinedIcon, progessMessage: "Eligibility reports are currently being developed." },
    { title: "Policy Wise Eligibility", icon: DescriptionOutlinedIcon, progessMessage: "Eligibility reports are currently being developed." },
  ] },
  { title: "Pre-Authorization", reports: [
    { title: "Pre-Auth Report", icon: FactCheckOutlinedIcon, path: "preauth/report/pre-auth" },
    { title: "Approved Report", icon: AssessmentOutlinedIcon, path: "preauth/report/approved" },
    { title: "Rejected Report", icon: AssignmentOutlinedIcon, path: "preauth/report/rejected" },
    { title: "Payer Wise Rejected Pre-Auth", icon: PercentOutlinedIcon, path: "preauth/report/impacts" },
    { title: "Pre-Auth KPI", icon: AssessmentOutlinedIcon, path: "preauth/report/kpi" },
  ] },
  { title: "Claims", reports: [
    { title: "GSS Report", icon: AssessmentOutlinedIcon, path: "claims/gss-report" },
    { title: "Claim Report", icon: AssignmentOutlinedIcon, path: "claims/claim-report" },
    { title: "Submission Report", icon: DescriptionOutlinedIcon, path: "claims/submission" },
    { title: "Submission History", icon: HistoryOutlinedIcon, path: "claims/history" },
    { title: "TPA Report", icon: AccountBalanceOutlinedIcon, path: "claims/tpa" },
    { title: "Ready Submission Claims", icon: FactCheckOutlinedIcon, path: "claims/report/ready-submission" },
    { title: "Claim Rejection Percentage", icon: PercentOutlinedIcon, path: "claims/report/rejection-percentage" },
    { title: "Claim Rejection Report", icon: AssignmentOutlinedIcon, path: "claims/report/rejection-report" },
    { title: "Claims Excel Report", icon: DescriptionOutlinedIcon, path: "claims/report/excel-file" },
  ] },
  { title: "Payments / Reconciliation", reports: [
    { title: "Payment Reports", icon: PaymentsOutlinedIcon, path: "payments" },
  ] },
  { title: "Price Reports", reports: [
    { title: "Cash Price List", icon: AttachMoneyIcon, path: "reports/cash-price-list" },
    { title: "Power-wide Price", icon: BoltIcon, path: "reports/power-wide-price" },
  ] },
];

const ReportSummary = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: { xs: 1, md: 1.5 } }}>
      <Typography variant="h5" sx={{ mb: 1.5, fontWeight: 700, color: "#17345f" }}>{t("Reports")}</Typography>
      <Box className="space-y-3">
        {reportGroups.map((group) => (
          <Box key={group.title}>
            <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight: 700, color: "#17345f" }}>{t(group.title)}</Typography>
            <Box className="grid grid-cols-1 gap-1.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
              {group.reports.map((report) => <CustomCard key={`${group.title}-${report.title}`} {...report} compact reportCard />)}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ReportSummary;
